import { createSlice } from "@reduxjs/toolkit";

const EXPIRY_TIME = 15 * 60 * 1000; // 15 minutes

const getStoredData = (key) => {
  const stored = localStorage.getItem(key);

  if (!stored) return null;

  try {
    const parsed = JSON.parse(stored);

    // Check expiry
    if (parsed.expiresAt && Date.now() > parsed.expiresAt) {
      localStorage.removeItem(key);
      return null;
    }

    return parsed.data;
  } catch (error) {
    localStorage.removeItem(key);
    return null;
  }
};

const storedPlan = getStoredData("bookingPlan");
const busDet = getStoredData("busDetail");

const defaultPlan = {
  boarding: "",
  dropping: "",
  time: "",
};

const defaultBus = {
  amenities: [""],
  availableDirections: {
    UP: true,
    DOWN: true,
  },
  busCategory: "",
  busClass: "",
  busName: "",
  busNumber: "",
  busType: "",
  dateInfo: {
    selectedDate: "",
    dayOfWeek: "",
    isPastDate: false,
    isToday: false,
  },
  defaultRoute: {
    timeSlot: 1,
    origin: {},
  },
  defaultSeatAvailability: {},
  fareDetails: {},
  id: "",
  images: [""],
  owner: {
    _id: "",
    name: "",
  },
  primaryImage: "",
  routes: [],
  searchCriteria: {
    from: "",
    to: "",
    date: "",
    timeSlot: 1,
  },
  seatConfiguration: {
    busType: "",
    totalSeats: 0,
  },
  totalSeats: 11,
  tripType: "",
  unAvailableSeats: [],
  videos: [],
};

const saveWithExpiry = (key, data) => {
  localStorage.setItem(
    key,
    JSON.stringify({
      data,
      expiresAt: Date.now() + EXPIRY_TIME,
    })
  );
};

const initialState = {
  plan: storedPlan || defaultPlan,
  bus: busDet || defaultBus,
};

const bookingSlice = createSlice({
  name: "booking",

  initialState,

  reducers: {
    setPlan: (state, action) => {
      state.plan = action.payload;

      saveWithExpiry("bookingPlan", state.plan);
    },

    setBus: (state, action) => {
      state.bus = action.payload;

      saveWithExpiry("busDetail", state.bus);
    },

    editPlan: (state, action) => {
      if (state.plan) {
        state.plan = {
          ...state.plan,
          ...action.payload,
        };

        saveWithExpiry("bookingPlan", state.plan);
      }
    },

    clearPlan: (state) => {
      state.plan = defaultPlan;

      localStorage.removeItem("bookingPlan");
    },

    clearBus: (state) => {
      state.bus = defaultBus;

      localStorage.removeItem("busDetail");
    },

    clearBooking: (state) => {
      state.plan = defaultPlan;
      state.bus = defaultBus;

      localStorage.removeItem("bookingPlan");
      localStorage.removeItem("busDetail");
    },
  },
});

export const {
  setPlan,
  editPlan,
  clearPlan,
  setBus,
  clearBus,
  clearBooking,
} = bookingSlice.actions;

export default bookingSlice.reducer;